module.exports = __webpack_public_path__ + "media/images/1544923318981-506add2dcb4e054769fd95f06eec9f21.jpg";